export const environment = {
  production: true,
  keycloak: {
    issuer: 'https://authentication.makeryworld.com/auth/',
    realm: 'Makery',
    clientId: 'makery-webshop-prod',
  },
  serviceUrl: 'https://webshop-api.makeryworld.com/',
  translateUrl:'https://webshop-api.makeryworld.com/download/translations/',
  wsUrl:"https://dashboard-api.makeryworld.com/makery-erp-websocket"
};
